<template>
  <div>
    <div class="title">对账详情</div>
    <!-- <div class="title">对账详情 <span :style="{color: total == 0 ? 'green' : 'red'}">({{total}})</span></div> -->
    <div>
      <div>
        <div class="h_title">
          <div class="h_title_icon"></div>
          <div>收支平衡</div>
        </div>
        <div class="h_container">
          <div>
            <div class="h_container_title">差额</div>
            <div class="h_container_money">{{ dataSource.signTotalEpg + ' - ' + dataSource.userTotalAmount + ' - ' + dataSource.busiTotalAmount + ' - ' + dataSource.busiWithdrawTotalAmount + ' - ' + dataSource.bulkyConsumeEpg + ' - ' + dataSource.mallConsumeEpg + ' = '}} <span :style="{color: total == 0 ? 'green' : 'red'}">{{total}}</span></div>
          </div>
        </div>
      </div>
      <div>
        <div class="h_title">
          <div class="h_title_icon"></div>
          <div>回收环保金总支出（可回收物+家电回收）</div>
        </div>
        <div class="h_container">
          <div>
            <div class="h_container_title">总支出</div>
            <div class="h_container_money">{{ dataSource.signTotalEpg }}</div>
          </div>
        </div>
      </div>
      <div>
        <div class="h_title">
          <div class="h_title_icon"></div>
          <div>用户剩余环保金总金额</div>
        </div>
        <div class="h_container">
          <div>
            <div class="h_container_title">总金额</div>
            <div class="h_container_money">
              {{ dataSource.userTotalAmount }}
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="h_title">
          <div class="h_title_icon"></div>
          <div>商家环保金总金额（剩余环保金 + 提现中环保金）</div>
        </div>
        <div class="h_container">
          <div>
            <div class="h_container_title">总金额</div>
            <div class="h_container_money">
              {{ dataSource.busiTotalAmount }}
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="h_title">
          <div class="h_title_icon"></div>
          <div>商家成功提现环保金</div>
        </div>
        <div class="h_container">
          <div>
            <div class="h_container_title">总金额</div>
            <div class="h_container_money">
              {{ dataSource.busiWithdrawTotalAmount }}
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="h_title">
          <div class="h_title_icon"></div>
          <div>大件清运用户支付环保金（净额）</div>
        </div>
        <div class="h_container">
          <div>
            <div class="h_container_title">总金额</div>
            <div class="h_container_money">
              {{ dataSource.bulkyConsumeEpg }}
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="h_title">
          <div class="h_title_icon"></div>
          <div>商城用户支付环保金总额（净额）</div>
        </div>
        <div class="h_container">
          <div>
            <div class="h_container_title">总金额</div>
            <div class="h_container_money">{{ dataSource.mallConsumeEpg }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { httpAction } from "@/api/manage";
import BigNumber from "bignumber.js"
// import { listMixin } from '@/mixins/listMixin'
export default {
  components: {},
  // mixins: [listMixin],
  props: {},
  computed: {
    total () {
      // return parseFloat(((this.dataSource.signTotalEpg * 1000 - this.dataSource.userTotalAmount * 1000 - this.dataSource.busiTotalAmount * 1000 - this.dataSource.busiWithdrawTotalAmount * 1000 - this.dataSource.bulkyConsumeEpg * 1000 - this.dataSource.mallConsumeEpg * 1000) / 1000).toPrecision(12))
      let signTotalEpg = new BigNumber(this.dataSource.signTotalEpg)
      let userTotalAmount = new BigNumber(this.dataSource.userTotalAmount)
      let busiTotalAmount = new BigNumber(this.dataSource.busiTotalAmount)
      let busiWithdrawTotalAmount = new BigNumber(this.dataSource.busiWithdrawTotalAmount)
      let bulkyConsumeEpg = new BigNumber(this.dataSource.bulkyConsumeEpg)
      let mallConsumeEpg = new BigNumber(this.dataSource.mallConsumeEpg)
      return signTotalEpg.minus(userTotalAmount).minus(busiTotalAmount).minus(busiWithdrawTotalAmount).minus(bulkyConsumeEpg).minus(mallConsumeEpg).toNumber()
    }
  },
  data() {
    return {
      url: {
        list: "/wlFinancialStatement/account",
      },
      dataSource: {},
    };
  },
  watch: {},
  created() {
    httpAction(this.url.list, {}, "get").then((res) => {
      if (res.code == 200) {
        this.dataSource = res.data;
      } else {
        this.$message.warning(res.msg);
      }
    });
  },
  methods: {
    fetchData() {
      console.log(this.ipagination.page);
    },
    add(val) {
      console.log(val);
    },
    edit(val) {},
    del(val) {},
  },
};
</script>

<style lang="scss" scoped>
.title {
  height: 60px;
  color: #333;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  line-height: 60px;
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #eee;
}

.h_title {
  height: 40px;
  color: #333;
  font-size: 16px;
  font-weight: bold;
  line-height: 40px;
  display: flex;
  align-items: center;
  background: #f7f7f7;
  padding: 0 10px;

  .h_title_icon {
    width: 4px;
    height: 16px;
    background: #ff6600;
    margin-right: 10px;
  }
}
.h_container {
  display: flex;
  justify-content: space-around;
  text-align: center;
  background: #f7f7f7;
  margin-bottom: 10px;
  padding: 10px;
  border: 2px solid #eee;

  .h_container_title {
    margin-bottom: 10px;
  }
  .h_container_money {
    font-size: 24px;
    font-weight: bold;
    color: #50bf3f;
  }
}
</style>
